export const LOAD_TRIAGES_SUCCESS = "LOAD_TRIAGES_SUCCESS";

export const LOAD_REFERRAL_TRIAGE_SUCCESS = "LOAD_REFERRAL_TRIAGE_SUCCESS";

export const TRIAGE_REFERRAL_SUCCESS = "TRIAGE_REFERRAL_SUCCESS";

export const REFERRAL_TRIAGE_TASKS_SUCCESS = "REFERRAL_TRIAGE_TASKS_SUCCESS";

export const LOAD_PPQ_TRIAGE_SUCCESS = "LOAD_PPQ_TRIAGE_SUCCESS";

export const PPQ_TRIAGE_TASKS_SUCCESS = "PPQ_TRIAGE_TASKS_SUCCESS";

export const PPQ_NO_FURTHER_ACTION_SUCCESS = "PPQ_NO_FURTHER_ACTION_SUCCESS";

export const PPQ_TEMPORARILY_UNFIT_SUCCESS = "PPQ_TEMPORARILY_UNFIT_SUCCESS";

export const LOAD_PHYSIOTHERAPY_REFERRAL_TRIAGE_SUCCESS = "LOAD_PHYSIOTHERAPY_REFERRAL_TRIAGE_SUCCESS";

export const TRIAGE_PHYSIOTHERAPY_REFERRAL_SUCCESS = "TRIAGE_PHYSIOTHERAPY_REFERRAL_SUCCESS";

export const PHYSIOTHERAPY_REFERRAL_TRIAGE_SUCCESSOR_TASKS_SUCCESS = "PHYSIOTHERAPY_REFERRAL_TRIAGE_SUCCESSOR_TASKS_SUCCESS";

export const GENERIC_CASE_TRIAGE_SUCCESSOR_TASKS_SUCCESS = "GENERIC_CASE_TRIAGE_SUCCESSOR_TASKS_SUCCESS";
export const LOAD_GENERIC_CASE_TRIAGE_SUCCESS = "LOAD_GENERIC_CASE_TRIAGE_SUCCESS";
export const TRIAGE_GENERIC_CASE_SUCCESS = "TRIAGE_GENERIC_CASE_SUCCESS";

export const LOAD_REFERRAL_TRIAGE = "LOAD_REFERRAL_TRIAGE";
export const LOAD_PPQ_TRIAGE = "LOAD_PPQ_TRIAGE";
export const LOAD_PHYSIOTHERAPY_REFERRAL_TRIAGE = "LOAD_PHYSIOTHERAPY_REFERRAL_TRIAGE";
export const LOAD_GENERIC_CASE_TRIAGE = "LOAD_GENERIC_CASE_TRIAGE";

export const PPQ_TEMPORARILY_UNFIT = "PPQ_TEMPORARILY_UNFIT";
export const PPQ_NO_FURTHER_ACTION = "PPQ_NO_FURTHER_ACTION";

export const TRIAGE_REFERRAL = "TRIAGE_REFERRAL";
export const TRIAGE_PHYSIOTHERAPY_REFERRAL = "TRIAGE_PHYSIOTHERAPY_REFERRAL";
export const TRIAGE_GENERIC_CASE = "TRIAGE_GENERIC_CASE";
